import request from '@/utils/request'

export function updateVersiontCfg(data) {
  return request({
    url: 'api/v1/version/updateCfg',
    method: 'post',
    data: data
  })
}

export function geVersiontCfg(data) {
  return request({
    url: 'api/v1/version/getCfg',
    method: 'get',
    data: data
  })
}
